export enum SignalRDetailsProperties {
  TimeStamp = 'Log Date',
  Status = 'Status',
  ConnectionType = 'Protocol',
  RemoteIpAddress = 'IP Address',
  EmailAddress = 'Email Address',
  SignalRClientId = 'Client Id',
}
